import { Component, type ErrorInfo, type ReactNode } from "react";
import { Button } from "@navio-maritime/ui";
import { captureAppError } from "../lib/observability";
import { EmptyState } from "./page";

interface Props {
  children: ReactNode;
}

interface State {
  failed: boolean;
}

export class ErrorBoundary extends Component<Props, State> {
  override state: State = { failed: false };

  static getDerivedStateFromError(): State {
    return { failed: true };
  }

  override componentDidCatch(error: Error, info: ErrorInfo) {
    captureAppError("React render failure", error, { componentStack: info.componentStack });
  }

  override render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div className="mx-auto max-w-3xl">
        <EmptyState title="Something went wrong">Reload the page. If this repeats, check the audit and observability logs.</EmptyState>
        <Button className="mt-3" variant="primary" onClick={() => window.location.reload()}>Reload</Button>
      </div>
    );
  }
}
